 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		49: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		49: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~83095350","1":"vendors~AISASection~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWi~f55fa7a8","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~MobileInternetFilter~ProductD~1499e4eb","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","10":"EshopLeasingDetailsView~ProductDetailsView","11":"MessageWidgetFlow","12":"vendors~FaqComponent~ProductListingCategory","13":"vendors~InstantPay~SpotifyBuyflowWidget","14":"AISASection","15":"ActivationFlow","16":"BuyFlow","17":"CalculatorWidget","18":"CaseManagementWidget","19":"EshopLeasingCatalogue","20":"EshopLeasingDetailsView","21":"FaqComponent","22":"GECheckUsageWidget","23":"GERoiForm","24":"HomeInternetFilter","25":"InstantPay","26":"MobileInternetFilter","27":"OtpWidget","28":"PickAndGoWidget","29":"PlanSelectionView","30":"PricePlanCards","31":"ProductCardCatalogue","32":"ProductDetailsView","33":"ProductListingCategory","34":"PromotionsWidget","35":"RedemptionFlow","36":"SAPDealsWidget","37":"SOGCardCatalogue","38":"SOGGiftCardDetails","39":"SOGRecommendations","40":"SpotifyBuyflowWidget","41":"StoreLocator","42":"SubscriptionFlow","43":"SubscriptionPage","44":"TradeInWidget","45":"TransactionResult","46":"VasMessageWidgetFlow","47":"WebSearchBar","50":"vendors~AISASection","51":"vendors~EshopLeasingCatalogue","52":"vendors~GECheckUsageWidget","53":"vendors~GERoiForm","54":"vendors~PickAndGoWidget","55":"vendors~PricePlanCards","56":"vendors~PromotionsWidget","57":"vendors~StoreLocator","58":"vendors~SubscriptionPage","59":"vendors~TradeInWidget","60":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"304bd56a","1":"b591394d","2":"9d1e2796","3":"6d31c765","4":"722bf5a7","5":"a525e6af","6":"ce89fdce","7":"3f17e94b","8":"36e4a40f","9":"70e779f6","10":"a113a329","11":"c543a867","12":"9df0c163","13":"e8fec304","14":"4bf327d6","15":"ec66a41d","16":"a85728d4","17":"75e34cbd","18":"730fa696","19":"9300de77","20":"54912354","21":"cf85820a","22":"9b1f486e","23":"7207ad84","24":"f91d2261","25":"52d18b37","26":"ad3dad1c","27":"a74c4711","28":"746491d5","29":"93fe7a8f","30":"81bd653f","31":"2d5212f2","32":"1c2d0c2c","33":"51d62ba8","34":"06801896","35":"6ab1b74c","36":"226bb36f","37":"c751f113","38":"f65919d9","39":"4ee258bb","40":"6b13a592","41":"4ffb78de","42":"b762b185","43":"56c40a86","44":"308eaaf0","45":"447064fd","46":"9677f353","47":"d8e425dd","50":"dd0686c0","51":"cbd8a504","52":"75c22b71","53":"8a29e3ca","54":"88f8f786","55":"f59b44df","56":"119a099f","57":"16f46050","58":"5a56d3d8","59":"eb5a67a3","60":"883be330","61":"e4080e5e","62":"dc48e0e9"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1,"38":1,"55":1,"60":1,"61":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"vendors~ActivationFlow~BuyFlow~CalculatorWidget~CaseManagementWidget~EshopLeasingDetailsView~HomeInt~83095350","1":"vendors~AISASection~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWi~f55fa7a8","2":"vendors~ActivationFlow~BuyFlow~CaseManagementWidget~FaqComponent~MessageWidgetFlow~OtpWidget~Product~3a563968","3":"vendors~ActivationFlow~BuyFlow~InstantPay~MessageWidgetFlow~OtpWidget~RedemptionFlow~SOGGiftCardDeta~3aa99e43","4":"CalculatorWidget~EshopLeasingDetailsView~HomeInternetFilter~InstantPay~MobileInternetFilter~ProductD~1499e4eb","5":"FaqComponent~PricePlanCards~ProductListingCategory~SubscriptionPage","10":"EshopLeasingDetailsView~ProductDetailsView","11":"MessageWidgetFlow","12":"vendors~FaqComponent~ProductListingCategory","13":"vendors~InstantPay~SpotifyBuyflowWidget","14":"AISASection","15":"ActivationFlow","16":"BuyFlow","17":"CalculatorWidget","18":"CaseManagementWidget","19":"EshopLeasingCatalogue","20":"EshopLeasingDetailsView","21":"FaqComponent","22":"GECheckUsageWidget","23":"GERoiForm","24":"HomeInternetFilter","25":"InstantPay","26":"MobileInternetFilter","27":"OtpWidget","28":"PickAndGoWidget","29":"PlanSelectionView","30":"PricePlanCards","31":"ProductCardCatalogue","32":"ProductDetailsView","33":"ProductListingCategory","34":"PromotionsWidget","35":"RedemptionFlow","36":"SAPDealsWidget","37":"SOGCardCatalogue","38":"SOGGiftCardDetails","39":"SOGRecommendations","40":"SpotifyBuyflowWidget","41":"StoreLocator","42":"SubscriptionFlow","43":"SubscriptionPage","44":"TradeInWidget","45":"TransactionResult","46":"VasMessageWidgetFlow","47":"WebSearchBar","50":"vendors~AISASection","51":"vendors~EshopLeasingCatalogue","52":"vendors~GECheckUsageWidget","53":"vendors~GERoiForm","54":"vendors~PickAndGoWidget","55":"vendors~PricePlanCards","56":"vendors~PromotionsWidget","57":"vendors~StoreLocator","58":"vendors~SubscriptionPage","59":"vendors~TradeInWidget","60":"vendors~WebSearchBar"}[chunkId]||chunkId) + "." + {"0":"304bd56a","1":"b591394d","2":"9d1e2796","3":"6d31c765","4":"722bf5a7","5":"a525e6af","6":"ce89fdce","7":"3f17e94b","8":"36e4a40f","9":"70e779f6","10":"a113a329","11":"c543a867","12":"9df0c163","13":"e8fec304","14":"4bf327d6","15":"ec66a41d","16":"a85728d4","17":"75e34cbd","18":"730fa696","19":"9300de77","20":"54912354","21":"cf85820a","22":"9b1f486e","23":"7207ad84","24":"f91d2261","25":"52d18b37","26":"ad3dad1c","27":"a74c4711","28":"746491d5","29":"93fe7a8f","30":"81bd653f","31":"2d5212f2","32":"1c2d0c2c","33":"51d62ba8","34":"06801896","35":"6ab1b74c","36":"226bb36f","37":"c751f113","38":"f65919d9","39":"4ee258bb","40":"6b13a592","41":"4ffb78de","42":"b762b185","43":"56c40a86","44":"308eaaf0","45":"447064fd","46":"9677f353","47":"d8e425dd","50":"dd0686c0","51":"cbd8a504","52":"75c22b71","53":"8a29e3ca","54":"88f8f786","55":"f59b44df","56":"119a099f","57":"16f46050","58":"5a56d3d8","59":"eb5a67a3","60":"883be330","61":"e4080e5e","62":"dc48e0e9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.aws.singtel.com/lux/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
